import { initGdlAction, resetGdlAction } from '../actions/api';
import { initEngineering } from '../actions/engineering';
import { modal } from '../actions/notification';
import {
  APP_SET_PAGE,
  GDL_INIT,
  GDL_INIT_SUCCESS,
  GDL_INIT_FAILURE,
  GDL_QUIT,
  GDL_RESET,
} from '../constants/app';
import { RESEARCH_SET_PAGE } from '../constants/research';
import {
  PAGE_OUTPUTS,
  PAGE_ENGINEERING,
  PAGE_SIMULATION,
} from '../constants/pages';
import {
  GAME_LEVEL_UP_SUCCESS,
  GAME_CHANGE_LEVEL_SUCCESS,
} from '../constants/game';
import { FM_SHOW } from '../constants/filemanager';

const unityPages = [PAGE_SIMULATION, PAGE_ENGINEERING, PAGE_OUTPUTS];

let initialized = false;
let loading = false;

const autoStartGdl = ({ dispatch, getState }) => (next) => (action) => {
  // look for quitGdl to reset initialized
  if (action.type === GDL_QUIT) {
    initialized = false;
    return next(action);
  }

  // reset gdl session on game mode levelup
  if (
    action.type === GAME_LEVEL_UP_SUCCESS ||
    action.type === GAME_CHANGE_LEVEL_SUCCESS
  ) {
    dispatch(resetGdlAction());
  }

  // no need to continue if we've already started
  if (initialized) {
    return next(action);
  }

  // these actions will require unity, which requires a GDL session to get the unity files
  let startGdl;
  switch (action.type) {
    case FM_SHOW:
      startGdl = true;
      break;
    case APP_SET_PAGE:
      if (unityPages.indexOf(action.page) > -1) {
        startGdl = true;
      }
      break;
    case RESEARCH_SET_PAGE:
      if (action.page.hasOwnProperty('unityScene')) {
        startGdl = true;
      }
      break;
    case GDL_INIT:
    case GDL_RESET:
      loading = true;
      break;
    case GDL_INIT_SUCCESS:
      loading = false;
      initialized = true;
      dispatch(initEngineering(action.result));
      break;
    case GDL_INIT_FAILURE:
      loading = false;
      dispatch(
        modal(
          'Error',
          'There was an error starting an engineering session.  Please reload the page and try again.',
          [],
          { sticky: true }
        )
      );
      break;
    default:
      startGdl = false;
      break;
  }

  // start, unless we've already started from a previous action
  if (!loading && startGdl) {
    dispatch(initGdlAction());
  }

  return next(action);
};

export default autoStartGdl;
